import { useHistory } from 'react-router-dom';

import { Button, DropdownMenu, Tooltip } from '@cobliteam/ui/components';

import { Location } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';
import { useOnboardingStore } from '@cobliteam/onboarding';

import Icon from '@cobliteam/ui/icons';

const HowToUseButton = () => {
  const hasOnboarding = useOnboardingStore((state) => state.hasOnboarding);

  const history = useHistory();

  return (
    <DropdownMenu>
      <Tooltip content='Como usar' asChild>
        <DropdownMenu.Trigger asChild>
          <Button variant='outlined' color='default' size='sm' icon={<Icon name='circle-help' />} onClick={() => Analytics.track('Navbar How To Use Button Clicked')} />
        </DropdownMenu.Trigger>
      </Tooltip>
      <DropdownMenu.Content align='end'>
        <DropdownMenu.Item
          onClick={() => {
            window.open('https://suporte.cobli.co/');
            Analytics.track('Navbar Help Center Button Clicked');
          }}
        >
          <DropdownMenu.Icon icon={<Icon name='circle-help' />} />
          <DropdownMenu.Label>Central de ajuda</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item
          onClick={() => {
            history.push(Location.TRAINING);
            Analytics.track('Cliquei para ir para treinamentos pela navbar');
          }}
        >
          <DropdownMenu.Icon icon={<Icon name='graduation-cap' />} />
          <DropdownMenu.Label>Ver treinamentos</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item
          onClick={() => {
            window.open('https://suporte.cobli.co/contato-cobli');
            Analytics.track('Navbar Contact Button Clicked');
          }}
        >
          <DropdownMenu.Icon icon={<Icon name='headset' />} />
          <DropdownMenu.Label>Contato</DropdownMenu.Label>
        </DropdownMenu.Item>

        {hasOnboarding && (
          <DropdownMenu.Item onClick={() => history.push(Location.ONBOARDING_SETUP)}>
            <DropdownMenu.Icon icon={<Icon name='book' />} />
            <DropdownMenu.Label>Guia de Implementação</DropdownMenu.Label>
          </DropdownMenu.Item>
        )}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default HowToUseButton;
